module.exports = __webpack_public_path__ + "images/map/map-cluster-e41c26a5ac0c73933025516538b59478.png";